import React from 'react';
import { Section, FieldGrid } from '../../components/EntityList';
import { useLabels } from '../../hooks/useLabels';

function AccountInfo({ account }) {
	const { t } = useLabels();

	if (!account) {
		return null;
	}

	const isEmpresa = account.type === 'Empresa';

	const left = [
		{ label: t('field.type'), value: account.type, required: true },
		{ label: t('field.name'), value: account.name, required: true },
		{ label: t('field.email'), value: account.email, copyable: true },
		{ label: t('field.phone'), value: account.phone, copyable: true },
		{ label: t('field.folder'), value: account.folder },
		{ label: t('field.observations'), value: account.observations, area: true },
	];

	const right = [
		{ label: 'Cuenta', value: account.internalId, mono: true },
		...(isEmpresa ? [{ label: t('field.rut'), value: account.rut, mono: true, copyable: true, required: true }] : []),
		{ label: t('field.address'), value: account.address },
		{ label: t('field.currency'), value: account.currency, mono: true },
		...(isEmpresa
			? [
				{
					label: t('field.bankAccountUSD'),
					value: account.bankAccountUSD
						? `${account.bankAccountUSD.bank} - ${account.bankAccountUSD.accountNumber}`
						: null,
				},
				{
					label: t('field.bankAccountUYU'),
					value: account.bankAccountUYU
						? `${account.bankAccountUYU.bank} - ${account.bankAccountUYU.accountNumber}`
						: null,
				},
			]
			: []),
	];

	return (
		<Section title={t('title.details')}>
			<FieldGrid left={left} right={right} />
		</Section>
	);
}

export default AccountInfo;
